export default "__VITE_ASSET__a9353aba__"